import type { CelestialBody } from '../types'

// Pyrithos, the star at the heart of System 404.
export const pyrithos: CelestialBody = {
  id: 'pyrithos',
  name: 'Pyrithos',
  type: 'star',
  tagline: 'The star at the heart of the trap.',
  lore: `Pyrithos is an orange to yellowish star, unremarkable, stable, not much special to it. It is the center of the trap that is System 404.

The danger is what orbits it, not the star itself. Still, ships running low on power learn to skirt close for a thermal top-up, and the inner worlds bake under it without mercy.`,
  render: {
    color: '#ffb24a',
    accent: '#ff7a3c',
    size: 34,
    orbitRadius: 0,
    orbitPeriod: 0,
  },
}
